import { TaskPanel } from '@/components/fleet/task-panel';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer';
import type { ActiveRun } from '@/hooks/use-fleet-action';

/**
 * Side panel for a per-server action run — opens when an action is triggered
 * and lives until the operator dismisses it. The task itself keeps running
 * (and the pending overlay stays) even if this panel is closed.
 */
export function TaskStatusPanel({
  activeRun,
  serverName,
  onDismiss,
}: {
  activeRun: ActiveRun | null;
  serverName: string;
  onDismiss: () => void;
}): JSX.Element {
  return (
    <Drawer
      open={activeRun !== null}
      onOpenChange={(open) => {
        if (!open) onDismiss();
      }}
    >
      <DrawerContent aria-describedby="task-panel-desc">
        {activeRun && (
          <>
            <DrawerHeader>
              <DrawerTitle>
                {activeRun.action.label} · task #{activeRun.taskId}
              </DrawerTitle>
              <DrawerDescription id="task-panel-desc">
                {serverName} — live status from the Provisioning API.
              </DrawerDescription>
            </DrawerHeader>
            <div className="overflow-y-auto">
              <TaskPanel taskId={activeRun.taskId} />
            </div>
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
}
